import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Details from '../views/Details.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/:vehicle/',
        name: 'Vehicle',
        component: Home
    },
    {
        path: '/:vehicle/detaljer/',
        name: 'Details',
        component: Details
    }
    //,{
    //  path: '/about',
    //  name: 'About',
    //  route level code-splitting
    //  this generates a separate chunk (about.[hash].js) for this route
    //  which is lazy-loaded when the route is visited.
    //  component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    //}
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        if ((to.path.indexOf('detaljer') > -1 && from.path.indexOf('detaljer') === -1) || (from.path.indexOf('detaljer') > -1 && to.path.indexOf('detaljer') === -1)) {
            return { x: 0, y: 0 };
        }
        return savedPosition;
    }
});

export default router;
